const getApiUrl = (endpoint = '') => {
  if (typeof window === 'undefined') return `http://localhost:3000${endpoint}`;

  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://localhost:3000${endpoint}`;
  }

  if (hostname.startsWith('projects.')) {
    return `https://${hostname.replace('projects.', 'app.')}${endpoint}`;
  }

  return `http://localhost:3000${endpoint}`;
};

export default getApiUrl;